import styled from "styled-components";
export const Scrollable = styled.div `
  height: 80vh;
  overflow: scroll;
`;
